// instructor dashboard
export const ANALYTICS = 'FETCH_ANALYTICS';
export const UPDATE_NOTIFICATION = 'UPDATE_ANALYTICS';
export const DELETE_NOTIFICATION = 'DELETE_ANALYTICS';

// student dashboard
export const ANALYTICS_STUDENTS = 'ANALYTICS_STUDENTS';

// defaults
export const ANALYTICS_ERROR = 'FETCH_ANALYTICS_ERROR';
export const DEFAULT = 'DEFAULT';

// like or dislike
export const ANAYLTICS_LIKE = 'ANAYLTICS_LIKE';
export const UPDATE_ANAYLTICS_LIKE = 'UPDATE_ANAYLTICS_LIKE';

export interface ViewSolutionEvent {
    engagementType: string;
    resourceName: string;
    resourceId: string;
    programId: string;
    programName: string;
    email: string;
}
